module.exports = __webpack_public_path__ + "static/img/blog_good_4.82a5cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_4.png
// module id = i2Ta
// module chunks = 8